<template> 
    <div style="border-radius: 50px">
        <!-- <div class="row q-pb-xs">
            <div class="col">
                <q-btn-toggle
                    spread
                    @click="resetToZero()"
                    v-model="Form.PercUnits"
                    toggle-color="primary"
                    :options="PercUnitOptions"
                    @input="PercUnitSelection(Form.PercUnits)"
                />
            </div>
        </div> -->
        
        <!-- <br> -->
        <div class="row">            
                <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm q-pb-md">
                    <b>{{$t("Switch.minSwitchUnit")}}</b>
                    <q-input 
                    class="text-right"
                    outlined
                    standout
                    :value="StoreStateT.Transaction.minSwitching | thousandSeparator"  
                    stack-label   
                    readonly/>                   
                </div>
				<div class="col-xs-12 col-sm-6 col-md-6 q-px-sm q-pb-md">
                    <b>{{$t("Switch.minAccountBal")}}</b>
                    <q-input
                    class="text-right"
                    outlined
                    standout
                    :value="StoreStateT.Transaction.minAccountBalance | thousandSeparator"  
                    stack-label 
                    readonly/>
                </div> 
            </div>
            <!-- <br> -->
        <div class="row">
            <div bottom-slots class="col-xs-12 col-sm-6 col-md-6 q-px-sm q-pb-xs" v-if="Form.PercUnits==='Percentage'">
                <b>{{$t("Switch.toswitchout")}}</b>
                <q-input  
                    mask="#.##"
                    fill-mask="0"
                    reverse-fill-mask
                    input-class="text-right"
                    outlined 
                    v-model="Form.PercSwitchOut" 
                    @keyup="CalcToUnit()"
                    suffix="%"
                    lazy-rules
                    :rules="[ val => val !== '' && val !== null && val !== 0 && val <=100 || 'Unit percentage must be less or equals to 100%']"
                />
            </div>
            <div bottom-slots class="col-xs-12 col-sm-6 col-md-6 q-px-sm" style="padding-bottom: 10px" v-if="Form.PercUnits==='Percentage'">
                <b>Converted to Units</b>
                
                <q-input
                    input-class="text-right"
                    outlined 
                    readonly
                    :value="Form.BalanceUnitFromPerc" 
                    lazy-rules
                    />
            </div>
           
            <div bottom-slots class="col-xs-12 col-sm-6 col-md-6 q-px-sm" style="padding-bottom: 10px" v-else-if="Form.PercUnits==='Units'">               
                <b>{{$t("Switch.units")}}</b>
                <q-input
                    outlined
                    ref="RefUnit"
                    v-model="Form.Units"
                    class=""
                    v-money="money"
                    input-class="text-right"   
                    :rules="[ val => parseFloat(RemoveFormat(val)) <=parseFloat(StoreStateT.Transaction.AvailableSwitching)   ||  '' + $t('Switch.availableUnit') +' '  + StoreStateT.Transaction.AvailableSwitching,
                    val => RemoveFormat(val) >= parseFloat(StoreStateT.Transaction.minSwitching)  || '' + $t('Switch.minSwitchUnit') +' ' + StoreStateT.Transaction.minSwitching ]">
                </q-input>
            </div>
            <!-- Min. Switching Unit -->
            <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm" v-if="StoreStateCD.Account.AccountType!=='PRS'"> 
                <b>{{$t("Switch.salescharge")}}</b>
                <q-input 
                    mask="#.##"
                    fill-mask="0"
                    reverse-fill-mask
                    input-class="text-right"
                    class="vertical-bottom" 
                    readonly
                    outlined 
                    v-model="Form.SalesCharge" 
                    suffix="%"
                    lazy-rules
                    :rules="[ val => val <= Form.MaxSalesCharge && val !== '' && val >= 0 || 'Must not more than ' + Form.MaxSalesCharge + '%']"
                />
            </div>
        </div>
        
        <div class="row">
            <div class="col q-px-sm">
                <b>{{$t("Switch.fundtoswitch")}}</b>
                <q-select
                    @click="GetFund()"
                    outlined
                    v-model="Form.SwitchFundName"
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    :options="FundList"
                    @input="PopulateFundDetails($event)"
                    @filter="FilterFund"
                    :rules="[ val => val !== '' && val !== null || '' + $t('Switch.genSwitchList') +' ']"
                    >
                    <template v-slot:no-option>
                        <q-item>
                        <q-item-section class="text-grey">
                            {{$t("common.label1")}}
                        </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div>

        
        </div>
        
        <!--<div class="row" v-if="Form.SwitchFundName!=''">
                    <div class="col-3">
                        <figure>
                            <img src="@/assets/pdf_icon.png" @click="openProspectus" label="Prospectus" style="height: 50px; max-width: 50px" />
                            <figcaption>Prospectus</figcaption>
                        </figure>
                    </div>
                    

                    <div class="col-3">
                        <figure>
                            <img src="@/assets/pdf_icon.png" @click="openHighlight" label="Prospectus" style="height: 50px; max-width: 50px" />
                            <figcaption>Product Highlight</figcaption>
                        </figure>
                    </div>
                    <div class="col-3">
                        <figure>
                            <img src="@/assets/pdf_icon.png" @click="openFundFact" label="Prospectus" style="height: 50px; max-width: 50px" />
                            <figcaption>Fund Fact Sheet</figcaption>
                        </figure>
                    </div>
                    <div class="col-3">
                        <figure>
                            <img src="@/assets/pdf_icon.png" @click="openBrochure" label="Prospectus" style="height: 50px; max-width: 50px" />
                            <figcaption>Brochure</figcaption>
                        </figure>
                    </div>
                   
        </div>-->
    </div>
</template>

<script>
import store from '../store';
import { mapState, mapActions } from "vuex";
import {VMoney, Money} from 'v-money'
export default {
    name: 'FundTransactionSwitching',
    components: {
    },
    props: ['Plan', 'ProductManagerMaster'],
    data () {
        return {
            StoreStateProduct : store.state.Product,
            StoreStateCD : store.state.CD,
            StoreStateBAD : store.state.BAD,
            StoreStateT : store.state.Transactions,
            StoreStateLookup : store.state.Lookup,
            StoreStateLogin: store.state.Login,
            StoreStateAPI : store.state.API,
            Form : {
                ErrorMsg :"",
                PercUnits : 'Units',
                Units : 0,
                SwitchFundCode : '',
                SwitchFundName : '',
                PercSwitchOut : 0.00,
                BalanceUnitFromPerc: '0.00',
                SalesCharge : 0.00,
                MaxSalesCharge : 0.00,
                DisagreeRecommendation : false
            },
            money: {
                decimal: '.',
                thousands: ',',
                precision: 2,
                masked: false /* doesn't work with directive */
            },
            AddBankAccount : false,
            PercUnitOptions : [
               /*  {label: '%', value: 'Percentage'}, */
                {label: 'Units', value: 'Units'}
            ],
            excludeEpfFundsByScheme : ["SJQFMYRNH"]
        }
    },
    directives: {money: VMoney},
      
    methods : {
    ...mapActions(["UpdateFundList","GetListOfFund","FilterFundOptions"]),
    RemoveFormat (obj){
             var vall= obj;
            vall = vall.replace(",","").replace(",","");
            vall = vall.replace(",","").replace(",","");
           // console.log(vall)
            return vall;
           // return parseFloat(vall).toFixed(2)
        },
    openProspectus:function(){
        window.open("https://nadiablob.blob.core.windows.net/funddoc/DF/PPT_Affin Hwang AIIMAN Income Plus Fund.pdf");
    },
    openHighlight:function(){
        
        window.open("https://nadiablob.blob.core.windows.net/funddoc/DF/PHS_Affin Hwang AIIMAN Income Plus Fund.pdf");
    },
    openFundFact:function(){
        
        window.open("https://nadiablob.blob.core.windows.net/funddoc/DF/FFS_FundFactSheetsAffinHwangAIIMANIncomePlusFund.pdf");
    },
    openBrochure:function(){
        
        window.open("https://nadiablob.blob.core.windows.net/funddoc/DF/B_ENG Affin Hwang AIIMAN Income Plus Fund.pdf");
    },
    
        FilterFund (val, update, abort) {
           
             

             if (val === '') {             
                update(() => {
                    this.UpdateFundList(this.FundOptionsFiltered)
                    
                    this.UpdateFundList(this.FundOptionsFiltered)
                })
                       
                return
            } else  if(val!=""){
                update(() => {
                    const needle = val.toLowerCase()
                    this.UpdateFundList(this.FundOptionsFiltered.filter(v => v.label.toLowerCase().indexOf(needle) > -1))

                   // this.$store.dispatch('UpdateFundList',this.StoreStateLookup.Schemes_LK.filter(v => v.value.toLowerCase().indexOf(needle) > -1))
                })
            }           


            this.$store.dispatch('Logging',
            {
                typeid :'4', 
                appid : '2',
                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' FilterFund -> '
            });
           /*   this.$store.dispatch('Logging',
            {
                typeid :'4', 
                appid : '2',
                str :  this.FundOptionsFiltered
            }); */
        },
        PercUnitSelection(selItem){
            this.Form.Units = 0;
            if(selItem==='All Units'){
                this.Form.Units = this.BalanceUnitB;
            }
        },
        CalcToUnit:function(){
            var value = 0;
           // console.log(this.Form.PercSwitchOut/100)
         value =  parseFloat(this.StoreStateT.Transaction.AvailableSwitching) * (parseFloat(this.Form.PercSwitchOut)/100)


                this.Form.BalanceUnitFromPerc=  value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                // this.Form.BalanceUnitFromPerc = parseFloat(this.Form.BalanceUnitFromPerc).toFixed(2
           
        },
        GetFund(){ 

            this.$store.dispatch('Logging',
            {
                typeid :'4', 
                appid : '2',
                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' GetFund-> ' + this.Plan 
            });

            this.FilterFundOptions({
                SophisticatedInvestor : this.StoreStateCD.CustomerDetails.SophisticatedInvestor,
                RiskProfile : this.StoreStateCD.SAT.Group,
                Disagree : this.Form.DisagreeRecommendation,
                Plan : this.Plan
            })
            .catch(function (error) {
              //  console.log(error);
                return 'error'
            });
        },
        PopulateFundDetails(Item){

            this.Form.SwitchFundCode = Item.value;
            this.Form.SwitchFundName = Item.label;
            this.Form.SalesCharge =0
            // Item.SalesCharge;
            this.Form.MaxSalesCharge = 0
            //Item.SalesCharge;
          
        },
        resetToZero(){
            this.Form.PercSwitchOut = 0;
            this.Form.Units = "0.00";
            if(this.Form.PercUnits==='Units'){
               this.$refs.RefUnit.$el.getElementsByTagName('input')[0].value = "0.00";
            }else{
                this.Form.PercSwitchOut = '';
                this.Form.Units = 0;
            }
                   
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(/,/g, '');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },  
    computed:{
      //  ...mapState({
       // FundOptions: state => state.Product.FundOptions,
       // FundOptionsFiltered: state => state.Product.FundOptionsFiltered,
       // FundList: state => state.Product.FundList,
       // FilteredFundPlan: state => state.Lookup.FundLookup.FilteredFundPlan
      //  }),
        FundOptionsFiltered (){
            return this.StoreStateProduct.FundOptionsFiltered;
        },
        FundList(){
            
            // this.StoreStateLookup.Schemes_LK
            /* this.StoreStateAPI.FundOptionsFiltered=[];
            for(var i=0;i< this.StoreStateLookup.Schemes_LK.length;i++){
            if((this.StoreStateLookup.Schemes_LK[i].FeeCharges!==undefined) && (this.StoreStateLookup.Schemes_LK[i].EPFStatus=="Approved")){
                for(var j=0;j<this.StoreStateLookup.Schemes_LK[i].FeeCharges.length;j++){
                    if(this.StoreStateLookup.Schemes_LK[i].Scheme != this.StoreStateCD.Transaction.FundSwitchOut ){
                        if("EPF"===this.StoreStateLookup.Schemes_LK[i].FeeCharges[j].Plan && this.StoreStateLookup.Schemes_LK[i].FeeCharges[j].FeeChargeTypeName==='Sales Charge'){
                            this.StoreStateAPI.TempFundList.push({ 
                                label:this.StoreStateLookup.Schemes_LK[i].label,
                                value:this.StoreStateLookup.Schemes_LK[i].value,
                                Scheme:this.StoreStateLookup.Schemes_LK[i].Scheme,
                                SchemeName:this.StoreStateLookup.Schemes_LK[i].SchemeName,
                                currency:this.StoreStateLookup.Schemes_LK[i].currency,
                                minintamount:this.StoreStateLookup.Schemes_LK[i].minintamount,
                                minaddamount:this.StoreStateLookup.Schemes_LK[i].minaddamount,
                                minswitchunits:this.StoreStateLookup.Schemes_LK[i].minswitchunits,
                                PRSAgeLowerBound:this.StoreStateLookup.Schemes_LK[i].PRSAgeLowerBound,
                                PRSAgeUpperBound:this.StoreStateLookup.Schemes_LK[i].PRSAgeUpperBound,
                                SalesCharge:this.StoreStateLookup.Schemes_LK[i].FeeCharges[j].RatePerc.toFixed(2),
                                producttype:this.StoreStateLookup.Schemes_LK[i].producttype,
                                ProductAssetClass : this.StoreStateLookup.Schemes_LK[i].ProductAssetClass,
                                RiskProfile : this.StoreStateLookup.Schemes_LK[i].RiskProfile,
                                FundStructure: this.StoreStateLookup.Schemes_LK[i].FundStructure,
                                Plan:this.StoreStateLookup.Schemes_LK[i].FeeCharges[j].Plan
                            });
                        }
                    }    
                }
            }
        } */

            let fundList = this.StoreStateAPI.TempFundList.filter(item => !this.excludeEpfFundsByScheme.includes(item.Scheme));

            // // Filter out if different fund manager
            let currentSchemeProductManager = this.StoreStateT.Transaction.productManagerMaster;
            fundList = fundList.filter(item => {return item.ProductManagerMaster == currentSchemeProductManager});

            return fundList;


            // return  this.StoreStateAPI.TempFundList
        },
          /*:rules="[ val => parseFloat(RemoveFormat(val)).toFixed(2) <= parseFloat(StoreStateT.Transaction.AvailableSwitching).toFixed(2)|| 'Switching unit must not exceed Available unit  ' + StoreStateT.Transaction.AvailableSwitching,
                    val => RemoveFormat(val) != 0.00|| 'Invalid input']" */
        isValid () {
            if(this.Form.Units != 0){
                var currentUnit =  this.Form.Units.replace(",","").replace(",",""); 
                var balanaceAvai  = parseFloat(this.StoreStateT.Transaction.AvailableSwitching).toFixed(2) 
                // currentUnit = parseFloat(this.Form.Units).toFixed(2)
                if(currentUnit >= balanaceAvai){
                  //  console.log(currentUnit + " --- "+ parseFloat(this.StoreStateT.Transaction.AvailableSwitching).toFixed(2))
                
                    this.Form.ErrorMsg = 'Switching unit must not exceed Available unit '
                    return false;
                }else{
                       // console.log(currentUnit + " ++  "+ parseFloat(this.StoreStateT.Transaction.AvailableSwitching).toFixed(2))
                
                }
            }
        },
 
        UnitsLeft : function(){
            // console.log("this.BalanceUnit"+parseFloat(this.BalanceUnit))
            // console.log("parseFloat(currencyOtherSum).toFixed(0)"+parseFloat(this.Form.Units).toFixed(2))
          
            var tempVall =""
            var Units = 0
            var FormatUnits =""
            var balanceUnitCalc=0;
            var FormatUnitsA=this.Form.Units.toString();

            for(var j=0; j<this.StoreStateCD.Holdings.length; j++){
                //alert(this.StoreStateCD.Holdings[j].BalanceUnit)
                balanceUnitCalc = this.BalanceUnit
            }

             if(FormatUnitsA.includes(',')){
                        FormatUnits=FormatUnitsA.replace(/,/g, '')
                        FormatUnits= FormatUnits.trim() 
                        parseFloat(FormatUnits).toFixed(2)
                        
                        //console.log(" FormatUnits ->"+ parseFloat(FormatUnits))
                        Units = balanceUnitCalc-parseFloat(FormatUnits).toFixed(2)
                        //console.log('total123--> ' +FormatUnits)
                }
                else{
                   parseFloat(FormatUnitsA).toFixed(2)
                   Units = balanceUnitCalc-FormatUnitsA 
                   //console.log('total--> ' +FormatUnitsA)
                }
            return parseFloat(Units).toFixed(2);
        
        }
    },  
    filters: {
        thousandSeparator: function(value) {
            if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
                value =  value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return value
                //.toFixed(2); 
            } else {
                return value
                //.toFixed(2);
            }
        },
        /* thousandSeparator_new: function(value) {
		        if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
                    value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                     var result = value;
                     return result
		        } else {
                    var result = value.toString();
                    return result
                }
     
          }  */
    }
}
</script>